import { fetch } from '@atlassian/eoc-fetch';
export const getResponderNames = requestedResponders => {
  const responders = requestedResponders.reduce((acc, curr) => {
    // any is intentional here we don't want to add
    // unknown to the ResponderType because we don't want it to be public
    if (curr.type === 'unknown') {
      return [...acc, {
        id: curr.id,
        type: 'schedule'
      }, {
        id: curr.id,
        type: 'user'
      }, {
        id: curr.id,
        type: 'team'
      }, {
        id: curr.id,
        type: 'escalation'
      }];
    }
    return [...acc, curr];
  }, []);
  return fetch(`/v1/alerts/responders/names`, {
    method: 'POST',
    body: {
      responders
    }
  });
};